module.exports = __webpack_public_path__ + "img/logo_suaracom.bb7682e2.png";